import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CfTask, TaskType} from "libs/web/shared/data-access/models/src";
import {TaskUtil} from "libs/web/shared/utils/src";

@Component({
  selector: 'as-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchResultComponent {
  @Input() task!: CfTask;
  get issueTypeIcon() {
    return TaskUtil.getTaskTypeIcon(TaskType.TASK);
  }
}
